import styled from 'styled-components'

export const CurrencyContainer = styled.div`
  padding: 12px 0px;
`

export const TableContainer = styled.div`
  margin-top: 20px;
`

export const Bold = styled.div`
  font-weight: 700;
`
